// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ping-circle[data-v-ed0b436e]\n{\n  color: red;\n  font-size: x-large;\n}\n.good[data-v-ed0b436e]\n{\n  color: green !important;\n}\n", ""]);
// Exports
module.exports = exports;
